











































































import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import SubBtn from "@/components/infrastructures/atoms/designed/SubBtn.vue";
import HpTitle from "@/components/infrastructures/atoms/text/HpTitle.vue";
import HpText from "@/components/infrastructures/atoms/text/HpText.vue";
import authService from "@/components/domains/authorization/authService";
import {AuthPolicy, formatRetireDate} from "@/components/domains/account/passwordless/authPolicy";
import PasswordlessService, {
  errorMessage,
  errorReason,
  FALLBACK_ERROR,
  loadAuthPolicy
} from "@/components/domains/account/passwordless/passwordlessService";

/** メールアドレスのないアカウント向けの「ユーザー名＋パスワード」ログイン（/login/username）。 */
@Component({
  components: {DefaultTemplate, PrimaryBtn, SubBtn, HpTitle, HpText}
})
export default class UsernameLoginPage extends Vue {
  name = "UsernameLoginPage";

  policy: AuthPolicy | null = null;
  retireDate = "";

  username = "";
  password = "";
  showPassword = false;
  error = "";
  useEmailLogin = false;
  submitting = false;

  mounted() {
    loadAuthPolicy({fresh: true}).then((policy) => {
      this.policy = policy;
      this.retireDate = formatRetireDate(policy.noEmailPasswordLoginRetiresAt);
    });
  }

  async login() {
    if (this.submitting) {
      return;
    }
    this.error = "";
    this.useEmailLogin = false;
    const username = this.username.trim();
    if (username === "" || this.password === "") {
      this.error = "ユーザー名とパスワードを入力してください。";
      return;
    }
    this.submitting = true;
    try {
      await PasswordlessService.loginWithUsername(username, this.password);
    } catch (e) {
      this.submitting = false;
      this.error = errorMessage(e, FALLBACK_ERROR);
      // メールアドレスがあるアカウント → メールでログインへ案内する。
      this.useEmailLogin = errorReason(e) === "NO_EMAIL_USE_EMAIL_LOGIN";
      return;
    }
    await authService.authMe();
    this.submitting = false;
    this.$router.push("/mypage");
  }
}
